import { Grid, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { Trans } from 'react-i18next';

import { RadioToggle } from '@/components/Form/RadioToggle';

import { useTranslate } from '@/hooks/useTranslate';

import { ClientType } from '@/types/user';

import { CustomerTypeSelectContainer } from './CustomerTypeSelect.styled';

export const CustomerTypeSelect = () => {
  const { control } = useFormContext();
  const { language } = useTranslate();

  return (
    <Grid item xs={12}>
      <CustomerTypeSelectContainer>
        <RadioToggle
          control={control}
          name="customerType"
          options={[
            {
              value: ClientType.New,
              label: (
                <Trans
                  i18nKey="login.newCustomer"
                  lang={language}
                  components={{
                    b: <Typography variant="body1Bold" component="span" />,
                  }}
                />
              ),
            },
            {
              value: ClientType.Existing,
              label: (
                <Trans
                  i18nKey="login.existingCustomer"
                  lang={language}
                  components={{
                    b: <Typography variant="body1Bold" component="span" />,
                  }}
                />
              ),
            },
          ]}
        />
      </CustomerTypeSelectContainer>
    </Grid>
  );
};
